export default __webpack_public_path__ + "static/no-floor-plan.3065c7ac0f864930845415351c88d6cd.svg";